import React, { useState, useEffect } from 'react';
import './style.css';
//import an image from current directory
import Logo from './ecozen-white.png';
import Title from './title.png';

const BASE_CO2 = 73281000; // Base value in kg CO2
const TOP_UP_RATE_1 = 1.466 / 60; // kg CO2 per second
const TOP_UP_RATE_2 = 9200 / 120; // kg CO2 per second
const START_TIMESTAMP = 1721001600; // Timestamp for July 15, 2024

const Ecozen: React.FC = () => {
  const [co2, setCO2] = useState<number>(0);

  useEffect(() => {
    const updateCO2 = () => {
      const now = Math.floor(Date.now() / 1000); // Current timestamp in seconds
      const elapsedSeconds = now - START_TIMESTAMP;
      const newCO2 = BASE_CO2 + (TOP_UP_RATE_1 + TOP_UP_RATE_2) * elapsedSeconds;
      setCO2(newCO2);
    };

    updateCO2(); // Initial update

    const interval = setInterval(() => {
      updateCO2();
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatCO2 = (value: number): string => {
    return value.toLocaleString('en-US', {
      // minimumIntegerDigits: 12,
      useGrouping: true,
      maximumFractionDigits: 0,
    });
  };

  return (
    <div className="App">
      <div className='background'>
        <div className='logo'>
          <img src={Logo} alt="Eco Smart" />
        </div>
        <div className='value'>{formatCO2(co2)}</div>
        <div className='title'>
          <img src={Title} alt="CO2 emissions counter" />
        </div>
      </div>
    </div>
  );
}

export default Ecozen;
